import React from "react";
import { SearchResults } from "./SearchPage";
import { Entry } from "../bookmarks/BookmarkPage";
import { RESULT_DOCUMENT_LIMIT } from "../../pages/search";
import { ResultsContainer } from "./PageResultsTab";
import EmptyResultsTab from "./EmptyResultsTab";
import SearchPagination from "./SearchPagination";

interface Props {
  results: SearchResults;
  page: number;
  name: string;
}

export default function DocumentTab(props: Props) {
  const { results, page } = props;
  if (!results.total) return <EmptyResultsTab />;

  return (
    <ResultsContainer>
      <SearchPagination
        {...results}
        name={name}
        renderItem={(item, idx) => (
          <Entry
            key={`${item.id}+${idx}`}
            id={item.id}
            {...item.image}
            title={item.title}
            href={item.image._src}
            isDownload={true}
          />
        )}
        renderEmpty={() => null}
        pageSize={RESULT_DOCUMENT_LIMIT}
        page={page - 1}
      />
    </ResultsContainer>
  );
}
